import { RouterProvider } from 'react-router-dom'
import './App.scss'
import router from './constants/router'
import { useEffect, useState } from 'react'
import { AgencyContext } from './contexts'
import LogRocket from 'logrocket'
import '@urbanx/agx-ui-components/dist/index.css'
import '@urbanx/agx.ui-components2/dist/agx.ui-components2.css'
import { AgxToasts, applyTheme } from '@urbanx/agx.ui-components2'
import { AgxAuth } from '@urbanx/agx.auth.client'
import AppConfig from 'config/AppConfig'
import ApiProviders from 'api/ApiProviders'
import { AgencyModel } from '@urbanx/agx.agencies.client'
import SignalrComms from 'api/SignalrComms'

// Generated manually from: https://uicolors.app/generate
const urbanXTheme = {
  main: [
    { scalePosition: 50, hexValue: '#ffffff', isBaseColour: true },
    { scalePosition: 100, hexValue: '#efefef', isBaseColour: false },
    { scalePosition: 200, hexValue: '#dcdcdc', isBaseColour: false },
    { scalePosition: 300, hexValue: '#bdbdbd', isBaseColour: false },
    { scalePosition: 400, hexValue: '#989898', isBaseColour: false },
    { scalePosition: 500, hexValue: '#7c7c7c', isBaseColour: false },
    { scalePosition: 600, hexValue: '#656565', isBaseColour: false },
    { scalePosition: 700, hexValue: '#525252', isBaseColour: false },
    { scalePosition: 800, hexValue: '#464646', isBaseColour: false },
    { scalePosition: 900, hexValue: '#3d3d3d', isBaseColour: false },
    { scalePosition: 950, hexValue: '#292929', isBaseColour: false },
  ],
  accent: [
    { scalePosition: 50, hexValue: '#f6f6f6', isBaseColour: false },
    { scalePosition: 100, hexValue: '#e7e7e7', isBaseColour: false },
    { scalePosition: 200, hexValue: '#d1d1d1', isBaseColour: false },
    { scalePosition: 300, hexValue: '#b0b0b0', isBaseColour: false },
    { scalePosition: 400, hexValue: '#888888', isBaseColour: false },
    { scalePosition: 500, hexValue: '#6d6d6d', isBaseColour: false },
    { scalePosition: 600, hexValue: '#5d5d5d', isBaseColour: false },
    { scalePosition: 700, hexValue: '#4f4f4f', isBaseColour: false },
    { scalePosition: 800, hexValue: '#454545', isBaseColour: false },
    { scalePosition: 900, hexValue: '#3d3d3d', isBaseColour: false },
    { scalePosition: 950, hexValue: '#000000', isBaseColour: true },
  ],
}

const App = () => {
  useEffect(() => {
    LogRocket.init('dzljjh/autopilot')

    applyTheme(urbanXTheme, 'staff-portal', true)
  }, [])

  const agency = useState<AgencyModel | undefined>(undefined)

  return (
    <AgxToasts>
      <AgxAuth apiConfig={AppConfig}>
        <ApiProviders>
          <AgencyContext.Provider value={agency}>
            <SignalrComms>
              <RouterProvider router={router} />
            </SignalrComms>
          </AgencyContext.Provider>
        </ApiProviders>
      </AgxAuth>
    </AgxToasts>
  )
}

export default App
